<template>
  <section>
    <v-container id="servicios" class="py-15 fill-height">
      <v-row justify="center" align="center" class="py-5">
        <v-col cols="10" md="5" class="ma-auto">
          <h1
            class="
              secondary--text
              text-h3 text-center text-xl-h2
              font-weight-thin
            "
          >
            {{ $t("servicios.titulo") }}
          </h1>
          <div v-scrollanimation class="hr verdeClaro my-5 mx-auto"></div>
          <p
            v-scrollanimation
            class="anim texto font-weight-light primary--text"
          >
            {{ $t("servicios.definicion") }}
          </p>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" class="pt-15">
        <v-col cols="11">
          <v-row align="start" justify="center">
            <v-col v-scrollanimation cols="12" md="4" class="anim d-flex">
              <v-img contain>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  v-scrollanimation
                >
                  <g
                    id="Desarrolo_proyectos"
                    data-name="Desarrolo proyectos"
                    transform="translate(0 0.092)"
                  >
                    <rect
                      id="Area"
                      width="34"
                      height="34"
                      transform="translate(0 -0.092)"
                      fill="#fcfcfc"
                      opacity="0"
                    />
                    <g id="Icon" transform="translate(4.24 4.226)">
                      <circle
                        id="Path"
                        cx="4.24"
                        cy="4.24"
                        r="4.24"
                        transform="translate(16.961 16.961)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <circle
                        id="Path-2"
                        data-name="Path"
                        cx="4.24"
                        cy="4.24"
                        r="4.24"
                        transform="translate(0 0)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <path
                        id="Path-3"
                        data-name="Path"
                        d="M10.833,5h4.24A2.827,2.827,0,0,1,17.9,7.827v9.893"
                        transform="translate(3.301 -0.76)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <line
                        id="Line"
                        y2="16.961"
                        transform="translate(4.24 8.48)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                    </g>
                  </g>
                </svg>
              </v-img>
              <div>
                <h3 class="ml-5">{{ $t("servicios.desarrollo") }}</h3>
                <p class="ml-5 font-weight-light">
                  {{ $t("servicios.desarrollotext") }}
                </p>
              </div>
            </v-col>
            <v-col v-scrollanimation cols="12" md="4" class="anim d-flex">
              <v-img>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                >
                  <g
                    id="Herramienta_software"
                    data-name="Herramienta software"
                    transform="translate(0 -0.264)"
                  >
                    <rect
                      id="Area"
                      width="34"
                      height="34"
                      transform="translate(0 0.264)"
                      fill="#fcfcfc"
                      opacity="0"
                    />
                    <g id="Icon" transform="translate(1.426 1.466)">
                      <rect
                        id="Rect"
                        width="22.816"
                        height="22.816"
                        rx="2"
                        transform="translate(4.278 4.278)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <rect
                        id="Rect-2"
                        data-name="Rect"
                        width="8.556"
                        height="8.556"
                        transform="translate(11.408 11.408)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <line
                        id="Line"
                        y2="4.278"
                        transform="translate(11.408 0)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <line
                        id="Line-2"
                        data-name="Line"
                        y2="4.278"
                        transform="translate(19.964 0)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <line
                        id="Line-3"
                        data-name="Line"
                        y2="4.278"
                        transform="translate(11.408 27.094)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <line
                        id="Line-4"
                        data-name="Line"
                        y2="4.278"
                        transform="translate(19.964 27.094)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <line
                        id="Line-5"
                        data-name="Line"
                        x2="4.278"
                        transform="translate(27.094 11.408)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <line
                        id="Line-6"
                        data-name="Line"
                        x2="4.278"
                        transform="translate(27.094 18.538)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <line
                        id="Line-7"
                        data-name="Line"
                        x2="4.278"
                        transform="translate(0 11.408)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <line
                        id="Line-8"
                        data-name="Line"
                        x2="4.278"
                        transform="translate(0 18.538)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                    </g>
                  </g>
                </svg>
              </v-img>
              <div>
                <h3 class="ml-5">{{ $t("servicios.produccion") }}</h3>
                <p class="ml-5 font-weight-light">
                  {{ $t("servicios.producciontext") }}
                </p>
              </div>
            </v-col>
            <v-col v-scrollanimation cols="12" md="4" class="anim d-flex">
              <v-img>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                >
                  <g id="Digitalizacion" transform="translate(0 0.44)">
                    <rect
                      id="Area"
                      width="34"
                      height="34"
                      transform="translate(0 -0.44)"
                      fill="#fcfcfc"
                      opacity="0"
                    />
                    <g id="Icon" transform="translate(2.802 4.137)">
                      <rect
                        id="Rect"
                        width="28.022"
                        height="19.615"
                        rx="2"
                        transform="translate(0 0)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <line
                        id="Line"
                        x2="11.209"
                        transform="translate(8.407 25.22)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <line
                        id="Line-2"
                        data-name="Line"
                        y2="5.604"
                        transform="translate(14.011 19.615)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                    </g>
                  </g>
                </svg>
              </v-img>
              <div>
                <h3 class="ml-5">{{ $t("servicios.digitalizacion") }}</h3>
                <p class="ml-5 font-weight-light">
                  {{ $t("servicios.digitalizaciontext") }}
                </p>
              </div>
            </v-col>
          </v-row>
          <v-row align="start" justify="center">
            <v-col v-scrollanimation cols="12" md="4" class="anim d-flex">
              <v-img contain>
                <svg
                  id="App_web"
                  data-name="App web"
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                >
                  <rect
                    id="Area"
                    width="34"
                    height="34"
                    fill="#fcfcfc"
                    opacity="0"
                  />
                  <g id="Icon" transform="translate(7.083 2.833)">
                    <rect
                      id="Rect"
                      width="19.833"
                      height="28.333"
                      rx="2"
                      transform="translate(0 0)"
                      fill="none"
                      stroke="#27debf"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.67"
                    />
                    <line
                      id="Line"
                      x2="0.014"
                      transform="translate(9.917 22.667)"
                      fill="none"
                      stroke="#27debf"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.67"
                    />
                  </g>
                </svg>
              </v-img>
              <div>
                <h3 class="ml-5">{{ $t("servicios.webapp") }}</h3>
                <p class="ml-5 font-weight-light">
                  {{ $t("servicios.webapptext") }}
                </p>
              </div>
            </v-col>
            <v-col v-scrollanimation cols="12" md="4" class="anim d-flex">
              <v-img>
                <svg
                  id="atencion"
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                >
                  <rect
                    id="Area"
                    width="34"
                    height="34"
                    fill="#fcfcfc"
                    opacity="0"
                  />
                  <g id="Icon" transform="translate(4.25 4.25)">
                    <path
                      id="Path"
                      d="M28,14.541a11.869,11.869,0,0,1-1.275,5.384,12.043,12.043,0,0,1-10.766,6.659,11.869,11.869,0,0,1-5.384-1.275L2.5,28l2.691-8.075a11.869,11.869,0,0,1-1.275-5.384A12.043,12.043,0,0,1,10.575,3.775,11.869,11.869,0,0,1,15.959,2.5h.707A12.012,12.012,0,0,1,28,13.834Z"
                      transform="translate(-2.5 -2.5)"
                      fill="none"
                      stroke="#27debf"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.667"
                    />
                  </g>
                </svg>
              </v-img>
              <div>
                <h3 class="ml-5">{{ $t("servicios.atencion") }}</h3>
                <p class="ml-5 font-weight-light">
                  {{ $t("servicios.atenciontext") }}
                </p>
              </div>
            </v-col>
            <v-col v-scrollanimation cols="12" md="4" class="anim d-flex">
              <v-img>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                >
                  <g
                    id="control_remoto"
                    data-name="control remoto"
                    transform="translate(0 0.174)"
                  >
                    <rect
                      id="Area"
                      width="34"
                      height="34"
                      transform="translate(0 -0.174)"
                      fill="#fcfcfc"
                      opacity="0"
                    />
                    <g id="Icon" transform="translate(2.822 2.795)">
                      <rect
                        id="Rect"
                        width="18.336"
                        height="18.336"
                        rx="2"
                        transform="translate(9.873 9.873)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                      <path
                        id="Path"
                        d="M5.9,20H4.487a2.82,2.82,0,0,1-2.82-2.822V4.487a2.82,2.82,0,0,1,2.82-2.82H17.181A2.82,2.82,0,0,1,20,4.487V5.9"
                        transform="translate(-1.667 -1.667)"
                        fill="none"
                        stroke="#27debf"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.667"
                      />
                    </g>
                  </g>
                </svg>
              </v-img>
              <div>
                <h3 class="ml-5">{{ $t("servicios.remoto") }}</h3>
                <p class="ml-5 font-weight-light">
                  {{ $t("servicios.remototext") }}
                </p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Landing4",
};
</script>

<style scoped>

#section {
  min-height: 100vh;
}

.ow-break-word {
  word-break: break-word;
}

.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}


.before-enter.card {
  opacity: 0;
  transform: translateY(50px);
  transition: all 1s ease-in-out;
}
/* 
    Si el elemento se cruza con la ventana gráfica, se agrega la clase antes de ingresar.
  */
.enter.card {
  opacity: 1;
  transform: translateY(0px);
}

.before-enter g {
  stroke-dasharray: 915;
  stroke-dashoffset: 915;
}

.enter g {
  stroke-dasharray: 915;
  stroke-dashoffset: 0;
  transition: all 5s ease-in-out;
}
</style>
